"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var noop = function () { };
var Toggle = /** @class */ (function (_super) {
    __extends(Toggle, _super);
    function Toggle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggleKeys = ['Enter', ' ']; // This matches <button> behavior
        _this.state = {
            on: _this.getOn({ on: !!_this.props.defaultOn }),
        };
        _this.setOn = function () { return _this.setOnState(true); };
        _this.setOff = function () { return _this.setOnState(false); };
        _this.toggle = function () { return _this.setOnState(); };
        _this.getTogglerProps = function (props) {
            if (props === void 0) { props = {}; }
            return (__assign({ 'aria-expanded': Boolean(_this.getOn()), tabIndex: 0 }, props, { onClick: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    if (props.onClick) {
                        props.onClick.apply(props, __spread(args));
                    }
                    _this.toggle();
                } }));
        };
        _this.setOnState = function (state) {
            if (state === void 0) { state = !_this.getOn(); }
            var cb = _this.getOn() === state
                ? noop
                : function () {
                    _this.props.onToggle(state, _this.getTogglerStateAndHelpers());
                };
            _this.setState({ on: state }, cb);
        };
        return _this;
    }
    Toggle.prototype.componentWillReceiveProps = function (_a) {
        var on = _a.on;
        if (on !== this.props.on && on !== this.state.on) {
            this.setOnState(on);
        }
    };
    Toggle.prototype.getOn = function (state, props) {
        if (state === void 0) { state = this.state; }
        if (props === void 0) { props = this.props; }
        return this.isOnControlled() ? !!props.on : !!state.on;
    };
    Toggle.prototype.isOnControlled = function () {
        return this.props.on !== undefined;
    };
    Toggle.prototype.getTogglerStateAndHelpers = function () {
        return {
            on: this.getOn(),
            getTogglerProps: this.getTogglerProps,
            setOn: this.setOn,
            setOff: this.setOff,
            toggle: this.toggle,
        };
    };
    Toggle.prototype.render = function () {
        return this.props.children(this.getTogglerStateAndHelpers());
    };
    Toggle.defaultProps = {
        defaultOn: false,
        onToggle: noop,
    };
    return Toggle;
}(React.Component));
exports.Toggle = Toggle;
//# sourceMappingURL=Toggle.js.map